const LEET: Record<string, string> = {
    '0': 'o', '1': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't', '@': 'a', '$': 's', '!': 'i',
};

// Blocked even when buried inside a longer name (shitface, xXfuckXx).
// Limited to words that rarely appear inside innocent words. Edit to taste.
const STRONG = [
    'fuck', 'shit', 'bitch', 'cunt', 'nigg', 'faggot', 'whore', 'slut',
    'bastard', 'asshole', 'dickhead', 'pussy', 'penis', 'vagina', 'porn',
];

export const containsHiddenProfanity = (name: string): boolean => {
    const cleaned = name
        .toLowerCase()
        .replace(/[013457@$!]/g, c => LEET[c] ?? c)   // sh1t -> shit
        .replace(/(.)\1{2,}/g, '$1')                   // shhhit -> shit
        .replace(/[^a-z]/g, ' ');                      // separators become spaces
    return STRONG.some(w => cleaned.includes(w));
};